// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { ISetupStepProps } from ".";
import styled from "@emotion/styled";
import isValidDomain from "is-valid-domain";
import { ChangeEvent, FC, FormEvent, useState } from "react";
import { useSelector } from "react-redux";

import { World } from "@livechat/design-system-icons";
import {
  DesignToken,
  FormField,
  Icon,
  Input,
  RadiusToken,
  SpacingToken,
  Text,
} from "@livechat/design-system-react-components";

import Block from "components/layout/Block";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { EmailDomainStatus } from "store/entities/email-domains/interfaces";
import { selectMaxEmailDomains } from "store/entities/license";
import { withVar } from "themes/helpers";

import { DomainSetupActionType, NewDomainAction } from "../DomainSetupModal";

import { LimitReachedBanner } from "./components";
import { StyledButton } from "./styles";

const DomainInputField = styled(Input)`
  .lc-input {
    width: 100%;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(${SpacingToken.Spacing2});
  width: 560px;
`;

const StyledForm = styled.form`
  padding: 16px;
  border: 1px solid ${withVar(DesignToken.BorderBasicPrimary)};
  border-radius: var(${RadiusToken.Radius3});
`;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const validateDomainName = (domainName: string) => {
  if (
    !isValidDomain(domainName) ||
    domainName.split(".").length === 1 ||
    domainName.split(".").some(part => part.length > 63)
  ) {
    return "Domain is invalid";
  }

  return undefined;
};

const SetupDomainName: FC<ISetupStepProps<NewDomainAction>> = ({
  setDomainName,
  domains,
  domainName,
  setModalAction,
}) => {
  const domainsLimit = useSelector(selectMaxEmailDomains);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fullyCustomDomains = domains.filter(({ dns }: any) => !!dns);
  const disableOnTeamPlan = fullyCustomDomains.length >= domainsLimit;
  const [validationError, setValidationError] = useState<string | null>(null);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleDomainNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setDomainName(event.target.value);
    setValidationError(null);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleDomainNameSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const existingDomain = domains.find((domain: any) => domain.name?.toLowerCase() === domainName.toLowerCase());
    const validation = validateDomainName(domainName);

    if (validation) {
      trackEngagement("Settings: Domain creation failure", EventPlace.Settings, {
        type: "custom",
        error: "Domain is invalid",
        domainName,
      });
      setValidationError(validation);
    } else if (
      existingDomain &&
      [EmailDomainStatus.Active, EmailDomainStatus.PendingVerification].includes(existingDomain.status)
    ) {
      trackEngagement("Settings: Domain creation failure", EventPlace.Settings, {
        type: "custom",
        error: "This domain name is already used. Please choose another domain name.",
        domainName,
      });
      setValidationError("This domain name is already used. Please choose another domain name.");
    } else {
      setModalAction({ type: DomainSetupActionType.NewDomain, domainName });
    }
  };

  return (
    <StyledForm id="domain-name-form" onSubmit={handleDomainNameSubmit}>
      <TitleWrapper>
        <Icon source={World} />
        <Text>Domain name</Text>
      </TitleWrapper>
      <Block marginTop={withVar(SpacingToken.Spacing4)}>
        <FormField labelText="Enter domain name" error={validationError ?? undefined} css={{ width: "100%" }}>
          <DomainInputField
            type="text"
            placeholder="yourdomain.com"
            id="domain-name"
            name="domain-name"
            value={domainName}
            error={!!validationError}
            onChange={handleDomainNameChange}
          />
        </FormField>
      </Block>
      {disableOnTeamPlan && <LimitReachedBanner domainsLimit={domainsLimit} />}
      <StyledButton
        size="compact"
        kind="primary"
        type="submit"
        form="domain-name-form"
        data-testid="add-custom-domain-continue"
        disabled={!domainName || disableOnTeamPlan}
      >
        Continue
      </StyledButton>
    </StyledForm>
  );
};

export { SetupDomainName };
